module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'fa ' + _vm.name,
    attrs: {
      "aria-hidden": "true"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d85542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/icon.vue
// module id = 563
// module chunks = 221